<template>
  <div :class="[checkboxMultiselectAll ? 'checkboxMultiselectAll' : '']">
    <div
      v-if="hasOptgroup"
      :class="['form-group']"
    >
      <select
        :class="['form-control ', classId]"
        multiple="multiple"
        data-fouc
        :disabled="disabled"
      >
        <template v-for="(items, keys) in options">
          <optgroup
            v-if="items.group"
            :key="`${keys}`"
            :label="items.group"
          >
            <option
              v-for="(value, key) in items.option"
              :key="'optgroup-' + value.id + `${key}`"
              :value="value.id"
              :disabled="value.disabled"
            >
              <div class="d-flex">
                <div
                  v-if="value.logo != '' && value.logo != undefined"
                  class="mr-2 overflow-hidden position-relative"
                  style="height: 25px; width: 25px"
                >
                  <img
                    :class="imageGroupClass"
                    class="w-100 h-100"
                    :src="value.logo"
                  >
                </div>
                <div class="flex-fill">
                  {{ value.name }}
                </div>
              </div>
            </option>
          </optgroup>

          <option
            v-else
            v-for="(value, key) in items.option"
            :key="'option-' + value.id + `${key}`"
            :value="value.id"
            :disabled="value.disabled"
          >
            <div class="d-flex">
              <div
                v-if="value.logo != '' && value.logo != undefined"
                class="mr-2 overflow-hidden position-relative"
                style="height: 25px; width: 25px"
              >
                <img
                  :class="imageGroupClass"
                  class="w-100 h-100"
                  :src="value.logo"
                >
              </div>
              <div class="flex-fill">
                {{ value.name }}
              </div>
            </div>
          </option>
        </template>
      </select>
    </div>
    <div
      v-else
      class="form-group"
    >
      <select
        :class="['form-control ', classId]"
        multiple="multiple"
        data-fouc
        :disabled="disabled"
      >
        <option
          v-for="(value, key) in options"
          :key="'option-' + value.id + `${key}`"
          :value="value.id"
          :disabled="value.disabled"
        >
          <div class="d-flex">
            <div
              v-if="value.logo != '' && value.logo != undefined"
              class="mr-2 overflow-hidden position-relative"
              style="height: 25px; width: 25px"
            >
              <img
                :class="imageClass"
                class="w-100 h-100"
                :src="value.logo"
              >
            </div>
            <div class="flex-fill">
              {{ value.name }}
            </div>
          </div>
        </option>
      </select>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    options: {
      type: [Object, Array],
      default: undefined,
    },
    enableHtml: {
      type: Boolean,
      default: false,
    },
    hasOptgroup: {
      type: Boolean,
      default: false,
    },
    includeSelectAllOption: {
      type: Boolean,
      default: false,
    },
    enableSelectAll: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableIfEmpty: {
      type: Boolean,
      default: false,
    },
    enableClickableOptGroups: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: null,
    },
    enableCaseInsensitiveFiltering: {
      type: Boolean,
      default: false,
    },
    resetMutiselect: {
      type: Boolean,
      default: false,
    },
    nonSelectedText: {
      type: String,
      default: "Please select...",
    },
    numberDisplayed: {
      type: String,
      Number,
      default: "1",
    },
    maxHeight: {
      type: String,
      Number,
      default: null,
    },
    selectedClass: {
      type: String,
      default: null,
    },
    selectAllText: {
      type: String,
      default: "Select all",
    },
    filterPlaceholder: {
      type: String,
      default: "Search",
    },
    includeFilterClearBtn: {
      type: Boolean,
      default: false,
    },
    checkboxMultiselectAll: {
      type: Boolean,
      default: false,
    },
    numberDisplayed: {
      type: Number,
      default: 3,
    },
    activeOption: {
      type: [Object, Array],
      default: undefined,
    },
    imageGroupClass: {
      type: String,
      default: "multiselect-group-image",
    },
    imageClass: {
      type: String,
      default: "multiselect-image",
    },
    limitSelect: {
      type: Number,
      default: 0,
    },
    checkboxDisplayShow: {
      type: Boolean,
      default: true
    }

  },
  data() {
    return {
      classId: "multiselect-full-featured-" + this.generate(),
      seleteOption: [],
      multiselect: "",
      // ### https://davidstutz.github.io/bootstrap-multiselect/index.html#getting-started
    };
  },
  async mounted() {
    await this.$nextTick();
    this.onChangeOption();
  },
  watch: {
    options: {
      async handler(newVal, oldVal) {
        if (newVal) {
          await this.$nextTick();
          this.onChangeOption()
          
          // update option เมื่อ data เปลี่ยน
          this.$emit("updated:data", true);
        }
      },
      immediate: true,
    },
    seleteOption: {
      handler(newVal, oldVal) {
        this.$emit("changeMultiSelect", newVal);
      }
    },
    activeOption: {
      async handler(newVal, oldVal) {
        // if (newVal) {
          await this.$nextTick();
          this.onChangeOption()
        // }
      },
      immediate: true,
    },
  },
  methods: {
    onChangeOption() {
      let vm = this;

      this.multiselect = $(`.${this.classId}`);

      this.multiselect.val(this.activeOption);
      if (this.activeOption) {
        this.seleteOption = this.activeOption;
      }

      let search = this.multiselect.closest('.multiselect-native-select').find(".multiselect-search").val()
      this.multiselect.multiselect({
        enableHTML: true,
        enableFiltering: true,
        includeSelectAllOption: this.includeSelectAllOption,
        disableIfEmpty: this.disableIfEmpty ? this.disableIfEmpty : false,
        enableClickableOptGroups: this.enableClickableOptGroups ? this.enableClickableOptGroups : false,
        buttonClass: this.buttonClass ? "btn btn-light " + this.buttonClass : "btn btn-light",
        enableCaseInsensitiveFiltering: this.enableCaseInsensitiveFiltering ? this.enableCaseInsensitiveFiltering : false,
        nonSelectedText: '<span style="color: #999;">' + this.nonSelectedText + "</span>",
        numberDisplayed: this.numberDisplayed ? this.numberDisplayed : null,
        maxHeight: this.maxHeight ? this.maxHeight : null,
        selectedClass: this.selectedClass ? this.selectedClass : null,
        selectAllText: this.selectAllText,
        filterPlaceholder: this.filterPlaceholder,

        onFiltering: function (option, checked) {
          let selected = vm.seleteOption = vm.multiselect.val();
          vm.$emit("onFiltering", {option, checked, selected});
        },
        onSelectAll: function (option, checked) {
          let selected = vm.seleteOption = vm.multiselect.val();
          vm.$emit("onSelectAll", {option, checked, selected});
        },
        onDeselectAll: function (option, checked) {
          let selected = vm.seleteOption = vm.multiselect.val();
          vm.$emit("onDeselectAll", {option, checked, selected});
        },
        onChange: function (option, checked) {
          let selected = vm.seleteOption = vm.multiselect.val();
          vm.$emit("onChange", {option, checked, selected});

          // แก้ปัญหา select all ไม่ unchecked เมื่อ checked ไม่ครบ
          var parent = $(option).closest('div').children().find('input[type="checkbox"]:not(:checked)').not('input[value="multiselect-all"]');
          var checkbox = $(option).closest('div').children().find('input[value="multiselect-all"]');
          if (!parent.length) {
            checkbox.prop('checked', true);
            return;
          }
          checkbox.prop('checked', false);
          
          if(vm.limitSelect > 0){
            if(vm.seleteOption.length >= vm.limitSelect){
              parent.prop('disabled', true);
              parent.closest('.multiselect-item').addClass('disabled');
            }else{
              parent.prop('disabled', false);
              parent.closest('.multiselect-item').removeClass('disabled');
            }
          }
          
        },
        optionLabel: function (element) {
          if (vm.enableHtml) {
            return $(element).attr("label") || $(element).html();
          }
          return $(element).attr("label") || $(element).text();
        },
        buttonText: function(options, select) {
          vm.$emit("isAllSelected", false);
          
          // without nonSelectedText, nSelectedText, numberDisplayed, numberDisplayed
          if (options.length === 0) {
            return `<span class="text-muted">${vm.nonSelectedText}</span>`;
          }

          var numberOfOptions = options.prevObject.length;
          if(options.length === numberOfOptions){
            vm.$emit("isAllSelected", true);
            return `${vm.$t('All Selected')} (${numberOfOptions})`;
          }

          var labels = [];
          options.each(function() {
            if ($(this).find('img').attr('src') !== undefined) {
              const html = `<dev>
                <img src="${$(this).find('img').attr('src')}" class="mr-1 position-absolute" style="height: 20px; width: 20px">
                <span class="ml-4">${$(this).children().children()[1].textContent.trim()}</span>
                </dev>`
              labels.push(html);
              return;
            }
            labels.push($(this).text().trim());
          });
          return labels.join(', ') + '';
        }
      });
      
      this.multiselect.multiselect('rebuild');
      if(search){
        this.$nextTick(() => {
          let searchElement = this.multiselect.closest('.multiselect-native-select').find(".multiselect-search");
          searchElement.val(search);
          searchElement.focus();
        });
      }
 
      if (this.enableSelectAll) {
        this.onSelectAll();
      }
      if(vm.resetMutiselect){
        vm.multiselect.closest('div.multiselect-native-select').find('div.multiselect-item.dropdown-item.form-check').removeClass('disabled');
        vm.multiselect.multiselect('deselectAll', false);
        vm.multiselect.multiselect('updateButtonText');
        vm.$emit("resetMutiSelectOptions", false);
      };
      if(this.checkboxDisplayShow) {
        $('.checkboxMultiselectAll .multiselect-all input[type="checkbox"]').css( "display", "none", "important")
        $('.checkboxMultiselectAll .multiselect-all span.form-check-control-indicator').css( "display", "none", "important")
        $('.checkboxMultiselectAll .multiselect-all label.form-check-label').css( "padding-left", "16px", "important")
      }
    },
    onSelectAll() {
      this.multiselect.multiselect('selectAll', false);
      this.multiselect.multiselect('updateButtonText');
      this.seleteOption = this.multiselect.val();
    },
    generate(value) {
      value = Math.random().toString(10).slice(2);
      return value;
    },
  },
};
</script>
<style>
input.form-control.multiselect-search {
  height: 37px;
}
.multiselect-group-image {
  border-radius: 0.1875rem;
  object-fit: cover;
}
.multiselect-image {
  border-radius: 0.1875rem;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/plugins/MultiSelect.vue